import { DependencyList, useEffect } from "react"
import { useEventCallback } from "src/components/hooks/useEventCallback"

/**
 * Using this over a regular effect avoids "Load failed" errors in iOS Safari on
 * early requests during page load.
 */
export function useOnLoadEffect(effect: () => void, dependencies: DependencyList = []) {
  const callback = useEventCallback(effect)

  useEffect(() => {
    if (document.readyState === "complete") {
      callback()
    } else {
      window.addEventListener("load", callback)
    }
    return () => {
      window.removeEventListener("load", callback)
    }
  }, [callback, ...dependencies])
}
